export enum AssistanceEditorCloseReason {
  GO_TO_CLIENT_PROFILE,
  MANUAL_CLOSE,
  CREATING_TEMPLATE,
  DELETED_MAIN_ASSISTANCE,
}
